import { getAllServices, queryAllSkills, executeAction } from './base';
import {
  getService,
  getAvailableServices,
  onServiceChanged,
  offServiceChanged,
  destroy,
} from './core/service-hub';

export default {
  getService,
  getAvailableServices,
  onServiceChanged,
  offServiceChanged,
  destroy,
  getAllServices,
  queryAllSkills,
  executeAction,
};
